import { createFeature, createReducer, on } from '@ngrx/store';
import { GlobalState, UserDetail } from '@smarsh-cyber/shared/models';
import { CHART_PORTAL } from '../app.constants';
import * as AppActions from './app.actions';

export const appFeatureKey = 'app';
const initialUserState: UserDetail = {
  userId: '',
  businessUnitName: '',
  username: '',
  role: '',
  businessUnitId: '',
  position_id: -1,
  profile: {
    fname: '',
    lname: '',
    phone: '',
    email: ''
  },
  permissions: [],
  status: null,
  masquerading: null
};

export const initialState: GlobalState = {
  user: initialUserState,
  userToken: {
    authToken: {
      accessToken: '',
      refreshToken: ''
    },
    tenantId: '',
    portalName: CHART_PORTAL,
    portalUrl: '',
    firmId: ''
  },
  isError: false,
  isLoaded: false,
  isLoading: false,
  businessUnits: [],
  error: null,
  factors: {
    factors: [],
    loaded: false
  },
  loggedInUser: initialUserState,
  isImpersonating: false
};

export const appFeature = createFeature({
  name: 'app',
  reducer: createReducer(
    initialState,
    on(AppActions.appInit, (state, action) => ({
      ...state,
      isLoading: true
    })),
    on(AppActions.ngpInit, (state, action) => ({
      ...state,
      isLoading: true
    })),
    on(AppActions.setPortalDetails, (state, action) => ({
      ...state,
      userToken: {
        ...state.userToken,
        portalName: action.portalName,
        portalUrl: action.portalUrl
      }
    })),
    on(AppActions.appLoadSuccess, (state, action) => ({
      ...state,
      user: action.appInit.user,
      userToken: {
        ...state.userToken,
        authToken: action.appInit.userToken.authToken,
        tenantId: action.appInit.userToken.tenantId,
        firmId: action.appInit.userToken.firmId
      },
      businessUnits: action.appInit.businessUnits,
      isError: false,
      isLoaded: true,
      isLoading: false,
      loggedInUser: action.appInit.user,
      isImpersonating: action.appInit.user.masquerading?.name ? true : false
    })),
    on(AppActions.appLoadFailure, (state, action) => ({
      ...state,
      isError: true,
      isLoaded: false,
      isLoading: false,
      error: action.error
    })),
    on(AppActions.refreshTokenSuccess, (state, action) => ({
      ...state,
      user: {
        ...state.user,
        tokenData: action.token
      },
      userToken: {
        ...state.userToken,
        authToken: action.token
      }
    })),
    on(AppActions.refreshTokenFailure, (state) => ({
      ...state,
      userToken: null
    })),
    on(AppActions.factorsActions.fetchSuccess, (state, action) => ({
      ...state,
      factors: action.data
    })),
    on(AppActions.factorsActions.fetchFailure, (state) => ({
      ...state,
      factors: {
        factors: [],
        loaded: false
      }
    })),
    on(AppActions.impersonate, (state, action) => {
      if (!action.userToBeImpersonated && action.userWithoutPermission) {
        return state;
      }
      return {
        ...state,
        user: action.userToBeImpersonated
          ? action.userToBeImpersonated
          : state.loggedInUser,
        isImpersonating: action.impersonate
      };
    }),
    on(AppActions.ngpLogout, (state) => {
      return {
        ...initialState,
        userToken: {
          authToken: {
            accessToken: '',
            refreshToken: ''
          },
          tenantId: '',
          portalName: state.userToken.portalName,
          portalUrl: state.userToken.portalUrl,
          firmId: state.userToken.firmId
        }
      };
    })
  )
});

export const {
  name,
  reducer,
  selectError,
  selectIsError,
  selectIsLoaded,
  selectBusinessUnits,
  selectUser,
  selectUserToken,
  selectAppState,
  selectFactors,
  selectIsImpersonating,
  selectLoggedInUser,
  selectIsLoading
} = appFeature;
